import Radium from '@flipdish/radium';
import React from 'react';
import * as Api from '../../Api';
import { COLLAPSE_TIME } from '../../constants/Constants';
import * as Data from '../../Data';
import * as Routes from '../../Routes';
import { Utilities } from '../../Utilities';

const tinycolor = require('tinycolor2');

interface Props {
  SectionLinksScroll: (offsetTime: number, menuSectionId: number) => any;
  Restaurant: Routes.RouteRestaurant;
  ExpandedState: number[];
  InitializeExpandedState: (vrid: number, expandedState: number[]) => any;
  AddToExpandedState: (vrid: number, menuSectionId: number) => any;
  vrid: number;
  translate: any;
  menu: Api.MenuReposnse | Api.ReadonlyMenuResponse;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
  concessionStoreId?: number;
}

interface State {}

class MenuHeader extends React.Component<Props, State> {
  public render(): JSX.Element {
    const {
      SectionLinksScroll,
      Restaurant,
      vrid,
      translate,
      menu,
      AppDesignScheme,
      isDark
    } = this.props;

    const displayed = menu.DisplaySectionLinks;

    let sectionHeaders = null;
    if (displayed) {
      sectionHeaders = Data.Sorted(menu.MenuSections).map((menuSection) => {
        switch (Restaurant.status) {
          case 'none':
          case 'pending':
            return null;
          default:
            break;
        }

        if (menuSection.MenuSectionAvailability) {
          switch (menuSection.MenuSectionAvailability.AvailabilityMode) {
            case Api.MenuEntityAvailabilityMode.DisplayBasedOnTimes:
              if (
                menuSection.MenuSectionAvailability.AvailableTimes != null &&
                !Utilities.isInPeriod(
                  menuSection.MenuSectionAvailability.AvailableTimes,
                  Restaurant.data.TimeZoneInfoId
                )
              ) {
                return null;
              }
              break;
          }
        }

        //Hacky fix for now
        if (
          menuSection.Name === 'Hidden Promotional Items' ||
          (this.props.concessionStoreId &&
            this.props.concessionStoreId != menuSection.ConcessionStoreId)
        ) {
          return null;
        }

        const styles = {
          section: {
            borderColor: tinycolor(AppDesignScheme.Primary)
              .darken(20)
              .toString(),
            background: tinycolor(AppDesignScheme.Primary)
              .darken(3)
              .toString(),
            boxShadow: `2px 2px 2px -3px ${AppDesignScheme.Secondary}`,
            WebkitBoxShadow: `2px 2px 2px -3px ${AppDesignScheme.Secondary}`,
            ':hover': {
              background: AppDesignScheme.Secondary
            },
            ':active': {
              background: tinycolor(AppDesignScheme.Secondary)
                .darken(10)
                .toString()
            }
          },
          darkSection: {
            borderColor: tinycolor(AppDesignScheme.Tertiary)
              .darken(10)
              .toString(),
            background: tinycolor(AppDesignScheme.Tertiary)
              .lighten(10)
              .toString(),
            boxShadow: `2px 2px 2px -3px ${tinycolor(AppDesignScheme.Tertiary)
              .lighten(10)
              .toString()}`,
            WebkitBoxShadow: `2px 2px 2px -3px ${tinycolor(AppDesignScheme.Tertiary)
              .lighten(10)
              .toString()}`,
            ':hover': {
              background: AppDesignScheme.Secondary
            },
            ':active': {
              background: tinycolor(AppDesignScheme.Secondary)
                .darken(10)
                .toString()
            }
          },
          tertiary: {
            color: AppDesignScheme.Tertiary
          },
          primary: {
            color: AppDesignScheme.Primary
          }
        };

        return (
          <div
            key={menuSection.MenuSectionId}
            className={`menu__sections__section flex flex-align-center flex-justify-center ${
              !menuSection.IsAvailable ? 'invisible' : ''
            }`}
            style={isDark ? styles.darkSection : styles.section}
            onClick={() => {
              const menuSectionElement = document.getElementById(menuSection.MenuSectionId);

              //If MenuBehaviour allows only one expanded section at a time then wait for previous section to collapse if expanded
              const OFFSET_TIME =
                menu.MenuSectionBehaviour == Api.MenuSectionBehaviour.ExpandSingle &&
                this.props.ExpandedState.length != 0
                  ? COLLAPSE_TIME
                  : 0;

              if (menu.MenuSectionBehaviour == Api.MenuSectionBehaviour.ExpandSingle) {
                this.props.InitializeExpandedState(vrid, [menuSection.MenuSectionId]);
              } else {
                this.props.AddToExpandedState(vrid, menuSection.MenuSectionId);
              }

              if (menuSectionElement) {
                //If there is a wait collapse the previous section
                if (OFFSET_TIME != 0) {
                  this.setState({}, () => {
                    SectionLinksScroll(OFFSET_TIME, menuSection.MenuSectionId);
                  });
                } else {
                  SectionLinksScroll(OFFSET_TIME, menuSection.MenuSectionId);
                }
              }
            }}
          >
            <p
              className="tertiary clear-margins fd-h4"
              style={
                Radium.getState(this.state, `${menuSection.MenuSectionId}`, ':hover') ||
                Radium.getState(this.state, `${menuSection.MenuSectionId}`, ':active')
                  ? styles.primary
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              {menuSection.Name === '' || menuSection.Name === 'Untitled Section'
                ? translate('Untitled_section')
                : menuSection.Name}
            </p>
          </div>
        );
      });
    }

    let sectionHeadersWrapped: JSX.Element = null;

    if (displayed) {
      //i.e. displayed, regardless of editMode
      sectionHeadersWrapped = <div className={`menu__sections flex`}>{sectionHeaders}</div>;
    }

    return <div className="flex">{sectionHeadersWrapped}</div>;
  }
}

export { MenuHeader };
export default Radium(MenuHeader);
